import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpErrorResponse, HttpResponse, HttpEvent, HttpRequest, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ValidationService } from '../services/validation.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class ValidationInterceptor implements HttpInterceptor {

  constructor(private validationService: ValidationService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        (resp: any) => {
          if (resp instanceof HttpResponse) {
            if (resp.status === 200 || resp.status === 204) {
              this.validationService.onClearValidationErrors.emit();
            }
          }
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 400) {
              return;
            }

            this.validationService.onValidationError.emit(err.error);
          }
        },
        () => {
        }
      )
    );
  }
}
